module.exports = __webpack_public_path__ + "assets/img/dots.954b436a.svg";